export function debounce<F extends (...args: any[]) => any, P extends Parameters<F>>(
  func: F,
  delay: number
): { (...args: [...P]): void; cancel: () => void } {
  let timeoutId: number;

  function debouncedFn(this: ThisType<never>, ...args: [...P]): void {
    window.clearTimeout(timeoutId);

    timeoutId = window.setTimeout(() => {
      func.apply(this, args);
    }, delay);
  }

  debouncedFn.cancel = (): void => {
    window.clearTimeout(timeoutId);
  };

  return debouncedFn;
}
